'use client'
import React, { useContext } from 'react'
import { TableContext } from '../../../../providers'
import { Spinner } from '../../../atoms'

export interface TableBodyProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode
    pagination?: JSX.Element
}

export const TableBody = ({ children }: TableBodyProps) => {
    const { hideHeader, hasBorder, isLoading } = useContext(TableContext)

    return (
        <tbody className={`text-shade-700${hideHeader && hasBorder ? ' border-t border-t-border-default' : ''}`}>
            {isLoading && (
                <tr className="table-component__spinner--loading">
                    <td colSpan={999}>
                        <Spinner />
                    </td>
                </tr>
            )}
            {children}
        </tbody>
    )
}
